export const SURVEY_UPDATED = "SURVEY_UPDATED";
export const SURVEY_SUBMITTED = "SURVEY_SUBMITTED";
export const SURVEY_FORWARDED = "SURVEY_FORWARDED";
export const SURVEY_SNOOZED = "SURVEY_SNOOZED";
